import Drawer from '@mui/material/Drawer';
import { SVGS } from '@zonofi/zono-money-design-system';
import {
  AvatarSizeVariants,
  ZoAvatar,
} from '@zonofi/zo-components/avatar/zo-avatar';
import {
  dispatch,
  getCustomerInvite,
  getIsSideDrawerOpen,
  updateIsSideDrawerOpen,
  useAppSelector,
} from '@zonofi/zono-money-store';
import React from 'react';
import './side-drawer.scss';
import { useSideDrawer } from './use-side-drawer';

const formatPhone = (phone: string): string => {
  if (!phone) return '';
  // Remove all non-digits
  const digits = phone.replace(/\D/g, '');
  // Format as +91-XXXX-XXXX-XXXX for 12 digits (country code + 10 digits)
  if (digits.length === 12) {
    return `+${digits.slice(0, 2)}-${digits.slice(2)}`;
  }
  // Format as +91-XXXX-XXXX-XXXX for 10 digits (without country code)
  if (digits.length === 10) {
    return `+91-${digits}`;
  }
  return phone;
};

export const SideDrawer = () => {
  const isOpen = useAppSelector(getIsSideDrawerOpen);
  const onClose = () => {
    dispatch(updateIsSideDrawerOpen(false));
  };
  const inviteData = useAppSelector(getCustomerInvite);
  const { sideDrawerItems } = useSideDrawer();
  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '80vw',
          bgcolor: '#fff',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '20px 16px',
          height: '100dvh',
          boxSizing: 'border-box',
          gap: '16px',
        },
      }}
    >
      <div className="zm-side-bar-header">
        <div className="zm-side-bar-header-seller-logo-container">
          {inviteData?.seller?.profileImg ? (
            <img src={inviteData?.seller?.profileImg} width={40} />
          ) : (
            <ZoAvatar
              title={inviteData?.seller?.name}
              variant={AvatarSizeVariants.LARGE}
              shape="square"
            />
          )}
        </div>
        <div className="zm-side-bar-header-customer-details">
          <div className="zm-side-bar-header-customer-details-name font-primary-semibold">
            {inviteData?.seller?.name}
          </div>
        </div>
        <img src={SVGS.CloseIconBlack} onClick={onClose} />
      </div>
      <div className="zm-side-bar-divider"></div>
      <div className="zm-side-bar-content">
        {sideDrawerItems.map((item) => (
          <div
            key={item.label}
            className="zm-side-bar-content-item"
            onClick={item.onClick}
          >
            <img src={item.icon} />
            <div className="zm-side-bar-content-item-label font-primary-semibold">
              {item.label}
            </div>
          </div>
        ))}
      </div>
      <div className="zm-side-bar-divider"></div>
      <div className="zm-side-bar-footer">
        <div className="zm-side-bar-footer-contact-us">Contact Us</div>

        <div className="zm-side-bar-footer-contact-details">
          <div className="zm-side-bar-footer-contact-row">
            {inviteData?.seller?.phone && (
              <div className="zm-side-bar-footer-contact-row-item">
                <img src={SVGS.PhoneOutlineBlack} />
                <a
                  className="zm-side-drawer-contact-link"
                  href={`tel:${inviteData.seller.phone}`}
                >
                  {formatPhone(inviteData.seller.phone)}
                </a>
              </div>
            )}

            {inviteData?.seller?.phone && inviteData?.seller?.email && (
              <span>|</span>
            )}

            {inviteData?.seller?.email && (
              <div className="zm-side-bar-footer-contact-row-item">
                <img src={SVGS.EnvelopOutlineBlack} />
                <a
                  className="zm-side-drawer-contact-link"
                  href={`mailto:${inviteData.seller.email}`}
                >
                  {inviteData.seller.email}
                </a>
              </div>
            )}
          </div>
        </div>

        <div className="zm-side-bar-footer-website">Powered by ZoTok</div>
      </div>
    </Drawer>
  );
};
